import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BillItem } from 'src/app/models/bill-item.model';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-add-concept-bill',
  template: `
    <ng-template #modalAddConceptBill let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Agregar servicio al recibo</h5>
        <button type="button" (click)="modal.dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="conceptForm">
          <div class="form-group ps-0 pe-0 mb-3">
            <label class="form-control-label">Concepto</label>
            <select class="form-select" formControlName="concept" (change)="selectConcept($event)">
              <option disabled>Concepto</option>
              <option *ngFor="let concept of concepts" [value]="concept.id">{{concept.name}}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="concept.id">
            <label class="form-control-label">Cantidad</label>
            <input type="number" class="form-control" formGroupName="quantity">
          </div>
          <div class="form-group mt-3" *ngIf="concept.id">
            <label class="form-control-label">Agregar descuento %</label>
            <input type="number" min="0" max="100" class="form-control" formControlName="discount">
          </div>
          <div class="form-group">
            <h5 class="mb-0"></h5>
          </div>
          <div class="form-group">
            <p class="mb-0"></p>
          </div>
          <div class="form-group mt-4" *ngIf="concept.id">
            <table class="table table-sm mt-2 border-0" style="font-size: 0.8em;">
              <tbody class="text-dark">
                <tr>
                  <td colspan="1" scope="col" class="text-start">
                    <strong>Servicio</strong>
                  </td>
                  <td colspan="1" scope="col" class="text-end">
                    <strong>{{ concept.name }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="1" scope="col" class="text-start">
                    <strong>Sub total</strong>
                  </td>
                  <td colspan="1" scope="col" class="text-end">
                    <small>{{ billItem.net_price | currency: 'USD' }}</small>
                  </td>
                </tr>
                <tr>
                  <td colspan="1" scope="col" class="text-start">
                    <strong>Descuento</strong>
                  </td>
                  <td colspan="1" scope="col" class="text-end">
                    <small>{{ billItem.discount_amount }}</small>
                  </td>
                </tr>
                <tr>
                  <td colspan="1" scope="col" class="text-start">
                    <strong>IVA ({{ concept.tax}} %)</strong>
                  </td>
                  <td class="text-end">
                    <small>{{ billItem.tax_amount | currency: 'USD'}}</small>
                  </td>
                </tr>
                <tr>
                  <td colspan="1" scope="col" class="text-start">
                    <strong>Total</strong>
                  </td>
                  <td class="text-end">
                    <strong><small>{{ concept.amount | currency: 'USD' }}</small></strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group text-end ps-0">
            <button type="button" class="btn btn-primary mt-4" [disabled]="!concept.id" (click)="addConcept()">
              <fa-icon [icon]="icons.faSave" class="me-2"></fa-icon> Agregar
            </button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styles: ``
})
export class ModalAddConceptBillComponent {
  @Input() concepts: any;
  @Output() conceptData = new EventEmitter<any>();
  @ViewChild('modalAddConceptBill') modalAddConceptBill: any;

  billItem: BillItem = {};

  cantidad: number = 0;
  concept: any = {};
  conceptForm: FormGroup = new FormGroup({});
  private modalRef: NgbModalRef | undefined;

  constructor(
    public icons: IconsService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.formInit();
  }

  formInit() {
    this.conceptForm = this.fb.group({
      concept: [''],
      quantity: [1],
      amount: [''],
      discount: [''],
      total: [''],
      clave: [''],
      codigo_unidad: [''],
      created_at: [''],
      id: [''],
      name: [''],
      sat_group: [''],
      tax: [''],
      updated_at: [''],
    });
  }

  selectConcept(event: any) {
    console.log(event.target.value);
    console.log('concepts ', this.concepts);
    this.concept = this.concepts.filter((concept: any) => concept.id == event.target.value)[0];
    console.log('concept ', this.concept);
    this.conceptForm.patchValue(this.concept);
    this.conceptForm.patchValue({
      quantity: 1,
    });

    const discount = this.conceptForm.value.discount ? this.conceptForm.value.discount : 0;
    const net_price = this.concept.amount/(1+this.conceptForm.value.tax/100) * this.conceptForm.value.quantity;

    this.billItem = {
      item_type: 'service',
      item_id: this.conceptForm.value.clave,
      quantity: this.conceptForm.value.quantity,
      price: net_price,
      discount_amount: discount,
      net_price: net_price,
      tax_rate: this.conceptForm.value.tax,
      tax_amount: this.concept.amount - (this.concept.amount/(1+this.conceptForm.value.tax/100)),
      total: this.concept.amount,
    };
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  addConcept() {
    console.log('add concept');    
    console.log(this.conceptForm.value);
    console.log('billItem', this.billItem);
    this.conceptData.emit(this.billItem);
    this.dismiss();
  }

  dismiss() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }

}
